export enum ChannelAnalogLevel {
	Line = 'LINE',
	Aux = 'AUX',
	Mic = 'MIC'
}
